(() => {
  const mount = document.getElementById("peachdrops-join-widget");
  if (!mount) return;

  const apiBase = (mount.getAttribute("data-api-base") || "").replace(/\/+$/, "");
  const dropId = (mount.getAttribute("data-peachdrops-drop-id") || "").trim();
  const productId = (mount.getAttribute("data-shopify-product-id") || "").trim();
  const productHandle = (mount.getAttribute("data-shopify-product-handle") || "").trim();
  const codeRequired = (mount.getAttribute("data-peachdrops-code-required") || "").toLowerCase() === "true";

  const url = new URL(window.location.href);
  const accessCode = (url.searchParams.get("code") || "").trim().toUpperCase();

  const params = new URLSearchParams();
  if (dropId) params.set("drop_id", dropId);
  if (productId) params.set("product_id", productId);
  if (productHandle) params.set("product_handle", productHandle);
  if (accessCode) params.set("code", accessCode);
  if (codeRequired) params.set("require_code", "1");

  if (!params.toString()) {
    mount.innerHTML = '<div style="padding:12px;border:1px solid #eee;border-radius:10px;">Missing drop lookup data.</div>';
    return;
  }

  const useStorefrontProxy = apiBase === "";
  const GET_URL = `/apps/interest?subpath=drop-info&${params.toString()}`;

  const POST_URL_SUBSCRIBE = useStorefrontProxy
    ? "/apps/interest?subpath=api/subscribe"
    : `${apiBase}/api/apps/interest/api/subscribe`;

  const POST_URL_WAITLIST = apiBase
    ? `${apiBase}/api/apps/interest/api/waitlist`
    : "";

  const esc = (s) => String(s ?? "").replace(/[&<>\"']/g, (c) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    "\"": "&quot;",
    "'": "&#39;",
  }[c]));

  const render = (html) => {
    mount.innerHTML = html;
  };

  const messageForReason = (reason) => {
    switch (reason) {
      case "missing_code":
        return "Message us on Nextdoor for your private link to join this drop.";
      case "used_code":
      case "code_used":
        return "This link has already been used. Message us on Nextdoor for your own link.";
      case "drop_closed":
        return "This drop is closed.";
      case "revoked_code":
        return "This link is no longer valid.";
      case "wrong_drop":
      case "invalid_code":
        return "This link is invalid. Message us on Nextdoor for your private link.";
      case "try_again":
        return "Too many requests. Please try again shortly.";
      default:
        return "This link is not available.";
    }
  };

  const renderMessageCard = (text) => {
    render(`
      <div style="padding:18px;border:1px solid #eee;border-radius:12px;">
        <div style="font-weight:700;font-size:20px;line-height:1.25;margin-bottom:10px;">Join Interest List</div>
        <div style="font-size:16px;line-height:1.5;opacity:.9;">${esc(text)}</div>
      </div>
    `);
  };

  if (codeRequired && !apiBase) {
    renderMessageCard("Configuration error: missing Widget API base URL.");
    return;
  }

  const renderForm = (payload) => {
    const drop = payload && payload.drop ? payload.drop : payload || {};
    const liveDropId = String(drop.id || drop.drop_id || dropId || "");
    const title = drop.title || payload.title || drop.product_title || `Drop #${liveDropId || "?"}`;
    const count = Number(drop.waitlist_count ?? drop.joined_qty ?? drop.reserved_count ?? drop.signups_count ?? 0);
    const threshold = Number(drop.threshold ?? drop.max_orders ?? drop.max_reserved ?? drop.window_limit ?? 0);

    if (codeRequired) {
      const access = payload && payload.access ? payload.access : {};
      if (!accessCode || access.code_valid !== true) {
        renderMessageCard(messageForReason(access.reason || (accessCode ? "invalid_code" : "missing_code")));
        return;
      }
    }

    const heading = codeRequired ? "Join Interest List" : "Reserve My Boxes";
    const buttonText = codeRequired ? "Join Interest List" : "Reserve My Boxes";

    render(`
      <div style="padding:18px;border:1px solid #eee;border-radius:12px;">
        <div style="font-weight:700;font-size:22px;line-height:1.2;margin-bottom:8px;">${esc(heading)}</div>
        <div style="opacity:.8;margin-bottom:14px;font-size:16px;line-height:1.45;">${esc(title)}</div>
        <div style="margin-bottom:14px;font-size:18px;line-height:1.3;">
          <strong>${count}</strong>${threshold ? ` of <strong>${threshold}</strong>` : ""} joined
        </div>

        <form id="pg-join-form" novalidate>
          <div style="display:grid;gap:12px;">
            <input name="name" placeholder="Full name (optional)" style="padding:14px 12px;font-size:16px;border:1px solid #d1d5db;border-radius:10px;">
            <input name="email" type="email" placeholder="Email" required style="padding:14px 12px;font-size:16px;border:1px solid #d1d5db;border-radius:10px;">
            <input name="quantity" type="number" min="1" value="1" required style="padding:14px 12px;font-size:16px;border:1px solid #d1d5db;border-radius:10px;">
            <button type="submit" style="padding:14px 16px;min-height:56px;font-size:18px;font-weight:700;border:0;border-radius:12px;cursor:pointer;background:#111827;color:#fff;">
              ${esc(buttonText)}
            </button>
            <div id="pg-join-msg" style="font-size:16px;line-height:1.45;"></div>
          </div>
        </form>
      </div>
    `);

    const form = mount.querySelector("#pg-join-form");
    const msg = mount.querySelector("#pg-join-msg");
    if (!form || !msg) return;

    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      msg.textContent = "Submitting...";
      msg.style.color = "";

      const fd = new FormData(form);
      const normalizedEmail = String(fd.get("email") || "").trim().toLowerCase();
      const quantity = Number(fd.get("quantity") || 1);

      const payloadBody = {
        drop_id: Number(liveDropId || dropId || 0),
        product_id: productId || undefined,
        product_handle: productHandle || undefined,
        name: fd.get("name"),
        email: normalizedEmail,
        quantity: quantity,
        source: codeRequired ? "nextdoor_dm_code" : "shopify_product_widget",
          page_url: window.location.href,
          shop: (window.Shopify && window.Shopify.shop) ? String(window.Shopify.shop) : "",
        };

      try {
        const endpoint = codeRequired ? POST_URL_WAITLIST : POST_URL_SUBSCRIBE;
        if (!endpoint) {
          throw new Error("Missing API base URL for code-required flow.");
        }
        const body = new URLSearchParams({
          drop_id: String(payloadBody.drop_id || ""),
          product_id: String(productId || ""),
          product_handle: String(productHandle || ""),
          name: String(payloadBody.name || ""),
          email: String(payloadBody.email || ""),
          quantity: String(payloadBody.quantity || 1),
          source: String(payloadBody.source || ""),
          page_url: String(payloadBody.page_url || window.location.href),
          shop: String(payloadBody.shop || ""),
          code: String(accessCode || ""),
          landing_url: String(window.location.href || ""),
          referrer: String(document.referrer || ""),
          utm_source: String(url.searchParams.get("utm_source") || ""),
          utm_medium: String(url.searchParams.get("utm_medium") || ""),
          utm_campaign: String(url.searchParams.get("utm_campaign") || ""),
          utm_content: String(url.searchParams.get("utm_content") || ""),
          utm_term: String(url.searchParams.get("utm_term") || ""),
        }).toString();

        const res = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            "Accept": "application/json",
          },
          body,
          credentials: "omit",
        });

        const data = await res.json().catch(() => ({}));
        if (!res.ok || data.ok === false) {
          throw new Error(data.message || data.error || `HTTP ${res.status}`);
        }
        if (codeRequired && data.status !== "joined") {
          throw new Error(data.message || "We could not complete your signup. Please try again.");
        }

        msg.textContent = data.message || (codeRequired
          ? `You're on the list. Save your code: ${accessCode}.`
          : "Success. Check your email if verification is required.");
        msg.style.color = "#166534";
      } catch (err) {
        msg.textContent = `Error: ${err && err.message ? err.message : "Request failed"}`;
        msg.style.color = "#b91c1c";
      }
    });
  };

  render('<div style="padding:12px;border:1px solid #eee;border-radius:10px;">Loading...</div>');

  fetch(GET_URL, { method: "GET", credentials: "omit" })
    .then(async (r) => ({ ok: r.ok, data: await r.json().catch(() => ({})) }))
    .then(({ ok, data }) => {
      if (!ok) throw new Error(data.message || "Failed to load drop");
      renderForm(data);
    })
    .catch((e) => {
      render(`<div style="padding:12px;border:1px solid #eee;border-radius:10px;">Could not load drop. ${esc(e.message)}</div>`);
    });
})();